module.exports = __webpack_public_path__ + "static/img/3.9721010.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/3.jpg
// module id = Tvjn
// module chunks = 1